import React from 'react';

import styled from 'styled-components';

export const Wrapper = styled.div``;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const TagButton = styled.div`
  border-radius: 16px;
  border: 1px solid rgb(213, 215, 216);
  background-color: var(--colorWhite);
  padding: 8px 16px;
  letter-spacing: 0.21px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 8px 0 0;
  color: var(--colorBlueGray1200);
  font-size: 12px;
  font-weight: 600;

  svg {
    cursor: pointer;
    color: var(--colorBlueGray600);
    margin-left: 5px;
    width: 16px;
    height: 16px;
  }
`;
